import React from 'react'
import {useSelector} from 'react-redux'
import styled from '@emotion/styled'
import {Button} from '@vio/atlas/Button'
import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'
import ContentWrapper from '@vio/atlas/helpers/ContentWrapper'
import {cssTheme} from '@vio/atlas/themes'

import {useBrand} from '@daedalus/core/src/_web/brand/hooks/useBrand'
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage'

import {FROZEN_DEAL_PARAM} from '../../hooks/useFrozenDealToast'
import {getError, getFreezeSelectedContext} from '../../modules/selector'
import {getSearchUrl} from '../../utils/url'
import {RemainingBooking} from './RemainingBooking'

const FixedContainer = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  z-index: 2;
  background-color: ${cssTheme.colors.background.neutral.c000};
`

const StickyContainer = styled.div`
  position: sticky;
  z-index: 2;
  bottom: 0;
  background-color: ${cssTheme.colors.background.neutral.c000};
`

const CtaWrapper = styled(ContentWrapper)`
  box-shadow: ${cssTheme.shadows.fixedReverse};
`

interface Props {
  remainingDeals?: number
}
export const CtaButton: React.FC<Props> = ({remainingDeals}) => {
  const {isMobile} = useDeviceLayout()
  const {hotel, searchDetail} = useSelector(getFreezeSelectedContext)
  const {brandSiteAddress} = useBrand()
  const {errored} = useSelector(getError)

  const Wrapper = isMobile ? StickyContainer : FixedContainer

  const handleBackToSearch = () => {
    const searchUrl = getSearchUrl(
      brandSiteAddress,
      hotel?.objectID as string,
      searchDetail.checkIn,
      searchDetail.checkOut,
      searchDetail.roomsSplit
    )
    location.assign(`${searchUrl}&${FROZEN_DEAL_PARAM}=1`)
  }

  if (errored) return null

  return (
    <Wrapper>
      <CtaWrapper
        paddingX={isMobile ? 's500' : 's700'}
        paddingBottom="s700"
        paddingTop="s500"
      >
        <RemainingBooking remainingDeals={remainingDeals} />
        <Button
          variant="primary"
          fullWidth
          size="xl"
          onClick={handleBackToSearch}
        >
          <FormattedMessageWrapper
            id="backToSearch"
            defaultMessage="Back to search"
          />
        </Button>
      </CtaWrapper>
    </Wrapper>
  )
}
